import { ReplaySubject } from 'rxjs'
import { baseurl } from "../util/config";
import { EventSourcePolyfill } from 'event-source-polyfill'
import { DateTime } from "luxon";
import { handleGrantThingPolicy, handleRegisterThing, handleRefreshToken } from "../service/adminUI";
import * as _ from "lodash";
import { realmpublickeypem,alg } from "../util/config";
import * as jose from 'jose';
import SessionManager from './SessionManager';

import dataTransmissionSecurity from './DataTransmissionSecurity';

//const Keycloak = require('keycloak-verify');  //to overcome the error related to Could not find a declaration file for module and when its @types not available

let knownNamespaces = ["pacemaker","message","syncTimer","symptom","mapper","charger","site","eCRF_subjects", "eCRF_enrollment",
                       "eCRF_preimplant", "eCRF_implant", "eCRF_followup1week", "eCRF_followup2week", "eCRF_followup1month",
                       "eCRF_followup3month", "eCRF_followup6month", "eCRF_followup9month", "eCRF_followup12month", "eCRF_followup18month", "eCRF_studycompletionORtermination",
                       "eCRF_adverseevent","eCRF_protocoldeviation", "eCRF_devicemalfunction"];

let eventTopicMap = new Map<string,string>();
//eventTopicMap.set("pacemaker", baseurl + 'api/2/things?namespaces=pacemaker');
//eventTopicMap.set("symptoms", baseurl + 'api/2/things?namespaces=symptoms');

_.forEach(knownNamespaces, function(namespace) {eventTopicMap.set(namespace, baseurl + 'api/2/things?namespaces='+namespace);})

let eventRxJsSubjectMap = new Map<string,ReplaySubject<any>>();
let eventSourceMap = new Map<string,EventSourcePolyfill>();
let historyURL = baseurl + 'api/2/things/';

// For Jest testing
let eventSourceTriggerMessage: any = null;

export interface UserInfo {
   userId:string,
   emailId:string,
   type:string
}

export interface Permisssions {
   policyowner?: UserInfo;
   rwowners?:UserInfo[];
   ronlyowners?:UserInfo[];
}

export class DTAL {
constructor(eventSubjectMap:Map<string,ReplaySubject<any>>) {
		eventRxJsSubjectMap = eventSubjectMap;
   }

async subscribe( event: string, callback?:(value: any) => void) {
   //determine event topic from event
   let topic = eventTopicMap.get(event);
   if(topic) {
   await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
   let accesstoken = SessionManager.getAccessToken();

   // Create secure request options with TLS enforcement and certificate pinning
   var eventSourceInitDict = dataTransmissionSecurity.createSecureRequest(topic, {
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'X-TLS-Version': '1.3',
        'X-Require-TLS': '1.2',
        'X-Force-TLS': 'true'
      },
    });

    let source = new EventSourcePolyfill(topic, eventSourceInitDict);
    source.onmessage = function (notifyEvent) {
         if((notifyEvent !== null) && (notifyEvent.data !== "")) {
         //get RxJS subject from eventRxJsSubjectMap using notifyEvent.data.thingId
         let sseResponse = JSON.parse(notifyEvent.data);
         let thingId = sseResponse.thingId;
         let event = thingId.split(":")[0] ?? "";
         let subject = eventRxJsSubjectMap.get(event);
         if(subject) {
            subject.next(sseResponse) //send the just the payload to RxJs subject
         }
         else {
            if(callback) callback(sseResponse); //invoke the callback if associated RxJS subject is not available for given event
         }
         }
    };

    // F4-10: Handle SSE errors (e.g. 401 token expiry) — refresh token and reconnect
    const currentEvent = event;
    source.onerror = async (err: any) => {
      // EventSource auto-reconnects on network errors, but a 401/403 means the token
      // has expired. Close the stale connection, refresh, and re-subscribe.
      if (err?.status === 401 || err?.status === 403) {
        source.close();
        eventSourceMap.delete(currentEvent);
        try {
          await SessionManager.refreshTokenIfNeeded(handleRefreshToken);
          await this.subscribe(currentEvent, callback);
        } catch (reconnectErr) {
          console.error('SSE reconnect failed after token refresh:', reconnectErr);
        }
      }
    };

 //jest testing
 if(process.env.JEST_WORKER_ID !== undefined) {
   eventSourceTriggerMessage = source.onmessage;
 }
	eventSourceMap.set(event,source);
}
		 
}

async unsubscribe( event: string) {
   let eventSource = eventSourceMap.get(event);
   if(eventSource) eventSource.close(); //close the event source
}

async gethistorical(identifier:string, fromversion:number, toversion:number, fromtimestamp:string, totimestamp:string, fields?:string, streamKey:string = "history"): Promise<ReplaySubject<any>|any>  {
   //validate the identifier
   let retValue = null;
   if(identifier)
   {
      //check the format
      if(identifier.indexOf(':') !== -1)
      {
         let isFromVersion = false;
         let isToVersion = false;
         let isFromTime = false;
         let isToTime = false;
         let ssePathParameter = ''  //to
         let headerVersionParameter = 0;
         let headerTimeParameter = '';
         let isHistorySSE = false;

         if ((fromversion !== null) && (fromversion > 0)) {
            isFromVersion = true;
            headerVersionParameter = fromversion;
         }
         if ((toversion !== null) && (toversion > 0)) {
            isToVersion = true;
            headerVersionParameter = toversion;
         }

         if ((fromtimestamp !== null) && (DateTime.fromISO(fromtimestamp).isValid)) {
            isFromTime = true;
            headerTimeParameter = fromtimestamp;
         }
         if ((totimestamp !== null) && (DateTime.fromISO(totimestamp).isValid)) {
            isToTime = true;
            headerTimeParameter = totimestamp;
         }

         //if version range exists
         if(isFromVersion && isToVersion)
         {
            //SSE
            isHistorySSE = true
            ssePathParameter=`?from-historical-revision=${fromversion}&to-historical-revision=${toversion}`
         }

         //if version range doesn't exist and time range exist
         if((!isHistorySSE) && (isFromTime) && (isToTime))
         {
            //SSE
            isHistorySSE = true
            ssePathParameter=`?from-historical-timestamp=${fromtimestamp}&to-historical-timestamp=${totimestamp}`

         }
         await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
         let accesstoken = SessionManager.getAccessToken();

         //subscribe to historical SSE events
         if(isHistorySSE) {
            let fieldParameter = fields?'&fields='+encodeURIComponent(fields):''
            let topic = baseurl + 'api/2/things/' + identifier + ssePathParameter + fieldParameter;
            //create a local RxJS subject for this stream
            let localEventSubject = new ReplaySubject<any>(1);
            //fetch authenicated token from current session
            var eventSourceInitDict = dataTransmissionSecurity.createSecureRequest(topic, {
               headers: {
                 Authorization: `Bearer ${accesstoken}`,
                 // "Content-Type": "application/merge-patch+json",
               },
             });
             let source =  eventSourceMap.get(streamKey);
             if(source != null) {
               source.close(); //close the previous eventsource for this key
             }
             source = new EventSourcePolyfill(topic, eventSourceInitDict);
             source.onmessage = function (notifyEvent) {
                  if((notifyEvent !== null) && (notifyEvent.data !== "")) {
                  //get RxJS subject from eventRxJsSubjectMap using notifyEvent.data.thingId
                  let sseResponse = JSON.parse(notifyEvent.data);
                  localEventSubject.next(sseResponse) //send the just the payload to RxJs subject
                  }
             };
             // Historical SSE should never auto-reconnect. When the server finishes
             // sending all revisions it closes the connection, which fires onerror.
             // We must close the EventSource immediately to prevent EventSourcePolyfill
             // from reconnecting and re-fetching the same data.
             const historicalStreamKey = streamKey;
             const historicalSource = source; // capture for closure (TS strict null safety)
             historicalSource.onerror = function (err: any) {
               historicalSource.close();
               eventSourceMap.delete(historicalStreamKey);
               localEventSubject.complete(); // signal stream end to subscribers
             };
            //jest testing
            if(process.env.JEST_WORKER_ID !== undefined) {
               eventSourceTriggerMessage = source.onmessage;
            }
            eventSourceMap.set(streamKey,source); //save the eventsource with its stream key
            retValue = localEventSubject;
         } else {
            //fetch a sample from historical data
            let requestOptions = dataTransmissionSecurity.createSecureRequest(historyURL+identifier, {});       
            if (headerVersionParameter) {
               requestOptions = dataTransmissionSecurity.createSecureRequest(historyURL+identifier, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + accesstoken,
                      'at-historical-revision' : headerVersionParameter
                  }
              });

            } else if (headerTimeParameter) {
               requestOptions = dataTransmissionSecurity.createSecureRequest(historyURL+identifier, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + accesstoken,
                      'at-historical-timestamp' : headerTimeParameter
                  }
              });               
               
            }

            const result = await fetch(historyURL+identifier, requestOptions);
            retValue = await result.json();
            

         }

      }
   }
   return retValue;
}

async create(identifier:string,data:JSON,permisssions:Permisssions={}) {
   if(identifier)
   {
      await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
      let accesstoken = SessionManager.getAccessToken();
      //check the format
      if(identifier.indexOf(':') !== -1)
      {
         let policyowner:UserInfo|object={};
         let rwowners:UserInfo[] = [{userId:'', emailId:'',type:''}]; //Read Write
         let ronlyowners:UserInfo[] = [{userId:'', emailId:'',type:''}]; //ReadOnly
         if(!_.isEmpty(permisssions)) {
            policyowner = permisssions?.policyowner ?? {};
            rwowners = permisssions?.rwowners ?? [];
            ronlyowners = permisssions?.ronlyowners ?? [];
         }
         //create thing with policy
         await handleRegisterThing(identifier,data,accesstoken,policyowner);
         //grant rights 
         if(rwowners) {
            //_.forEach(rwowners, function(permission) {
            for (const permission of rwowners) {   
               await handleGrantThingPolicy(identifier,permission.userId,accesstoken,permission.emailId,permission.type,true)
             };
         }
         if(ronlyowners) {
            //_.forEach(ronlyowners, function(permission) {
            for (const permission of ronlyowners) {   
               await handleGrantThingPolicy(identifier,permission.userId,accesstoken,permission.emailId,permission.type,false)
             };
         }

      }
   }   

}

async fetch(namespace:string,filterexp:string,fields:string) {
   let retValue = {};
   if(namespace)
   {
      await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
      let accesstoken = SessionManager.getAccessToken();
      //validate against known namespaces
      let validnamespace =_.filter(knownNamespaces, _.matches(namespace));
      if(!_.isEmpty(validnamespace))
      {
         let url = baseurl + 'api/2/search/things?namespaces=' + encodeURIComponent(namespace);
         if(filterexp && !_.isEmpty(filterexp)) {
            url += '&filter='+ encodeURIComponent(filterexp);
         }
         if(fields && !_.isEmpty(fields)) {
            url += '&fields='+ encodeURIComponent(fields);
         }
         const requestOptions = dataTransmissionSecurity.createSecureRequest(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accesstoken
            }
        });
        const result = await fetch(url, requestOptions);
        if ((result.ok) && (result.status === 200)) {
          retValue = await result.json();
         
        } 

      }
   }
   return retValue;  

}

async get(identifier:string) {
   let retValue = {};
   if(identifier)
   {
      await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
      let accesstoken = SessionManager.getAccessToken();
      //check the format
      if(identifier.indexOf(':') !== -1)
      {
         let namespace = identifier.split(":")[0];
         //validate against known namespaces
         let validnamespace =_.filter(knownNamespaces, _.matches(namespace));
         if(!_.isEmpty(validnamespace))
         {         
            let url = baseurl + 'api/2/things?ids=' + encodeURIComponent(identifier);
            const requestOptions = dataTransmissionSecurity.createSecureRequest(url, {
               method: 'GET',
               headers: {
                   'Content-Type': 'application/json',
                   'Authorization': 'Bearer ' + accesstoken
               }
           });
           const result = await fetch(url, requestOptions);
           if ((result.ok) && (result.status === 200)) {
             retValue = await result.json();            
            }
         }
      }
   }
   return retValue;
}

async set(identifier:string,data:JSON) :Promise<boolean|JSON>{
   let retValue = false;
   if(identifier)
   {
      await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
      let accesstoken = SessionManager.getAccessToken();
      //check the format
      if(identifier.indexOf(':') !== -1)
      {
         let namespace = identifier.split(":")[0];
         //validate against known namespaces
         let validnamespace =_.filter(knownNamespaces, _.matches(namespace));
         if(!_.isEmpty(validnamespace))
         {         
            let url = baseurl + 'api/2/things/' + identifier;
            const requestOptions = dataTransmissionSecurity.createSecureRequest(url, {
               method: 'PUT',
               headers: {
                   'Content-Type': 'application/json',
                   'Authorization': 'Bearer ' + accesstoken
               },
               body: JSON.stringify(data)
           });
           const result = await fetch(url, requestOptions);
           if ((result.ok) && (result.status === 200)) {
             retValue = await result.json();            
           } else if ((result.ok) && (result.status === 204)) {
               retValue = true;
           } else {
               const value = await result.json();
               retValue = value;
           }
         }
      }
   }
   return retValue;
}

async patch(identifier:string,data:JSON) :Promise<boolean|JSON>{
   let retValue = false;
   if(identifier)
   {
      await SessionManager.refreshTokenIfNeeded(handleRefreshToken); // ensure token is fresh
      let accesstoken = SessionManager.getAccessToken();
      //check the format
      if(identifier.indexOf(':') !== -1)
      {
         let namespace = identifier.split(":")[0];
         //validate against known namespaces
         let validnamespace =_.filter(knownNamespaces, _.matches(namespace));
         if(!_.isEmpty(validnamespace))
         {         
            let url = baseurl + 'api/2/things/' + identifier;
            const requestOptions = dataTransmissionSecurity.createSecureRequest(url, {
               method: 'PATCH',
               headers: {
                   'Content-Type': 'application/merge-patch+json',
                   'Authorization': 'Bearer ' + accesstoken
               },
               body: JSON.stringify(data)
           });
           const result = await fetch(url, requestOptions);
           if ((result.ok) && (result.status === 200)) {
             retValue = await result.json();            
           } else if ((result.ok) && (result.status === 204)) {
               retValue = true;
           } else {
               const value = await result.json();
               retValue = value;
           }
         }
      }
   }
   return retValue;
}

async validatejwt(accessToken:string): Promise<boolean> {
   let retValue = false;
/*    const config = { publicKey: keycloakcfg.public_key };
   const keycloak = Keycloak(config);
   try {
      const user = await keycloak.verifyOffline(accessToken);
      retValue = true;
   } catch(e){ console.log(e) } */

   try {
         const publicKey = await jose.importSPKI(realmpublickeypem, alg)
         const { payload } = await jose.jwtVerify(accessToken, publicKey)
         if(!_.isEmpty(payload)) { retValue = true}
   } catch(e){ console.error('JWT validation failed:', e) } 


   return retValue;
}

}

export { eventSourceTriggerMessage };